import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'GroupPermissionsSectionContainer'

    static propTypes = {
      group: PropTypes.object.isRequired,
      handlePermissionsSet: PropTypes.func.isRequired,
    }

    state = {
      selectedPermissions: this.props.group.permissions,
    }

    handlePermissionSelection = (key, path) => {
      const { selectedPermissions } = this.state

      if (selectedPermissions.includes(key)) {
        this.setState({ selectedPermissions: selectedPermissions.filter(p => p !== key) })
      } else {
        this.setState(prevState => ({ selectedPermissions: [...prevState.selectedPermissions, key] }))
      }
    }

    handlePermissionsSubmit = () => {
      const { handlePermissionsSet } = this.props
      const { selectedPermissions } = this.state

      handlePermissionsSet(selectedPermissions)
    }

    render() {
      return (
        <WrappedComponent
          handlePermissionsSubmit={this.handlePermissionsSubmit}
          handlePermissionSelection={this.handlePermissionSelection}
          {...this.props}
          {...this.state}
        />
      )
    }
  }

  return Container
}
